import React from 'react';
import { Navigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { getDefaultRouteForRole, isRoleAllowed } from '../utils/roleUtils';

export const FullPageLoader = ({ message = 'Loading...' }) => (
  <Box
    sx={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      gap: 2,
      bgcolor: 'background.default',
      color: 'text.primary',
    }}
  >
    <CircularProgress color="primary" />
    {message ? <Typography variant="body2">{message}</Typography> : null}
  </Box>
);

export const ProtectedRoute = ({ children, session, isLoading, allowedRoles = [] }) => {
  if (isLoading) {
    return <FullPageLoader />;
  }

  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  if (!isRoleAllowed(session, allowedRoles)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return children;
};

export const PublicRoute = ({ children, session, isLoading }) => {
  if (isLoading) {
    return <FullPageLoader />;
  }

  if (session && session.uid) {
    return <Navigate to={getDefaultRouteForRole(session)} replace />;
  }

  return children;
};

export default ProtectedRoute;
